import clonedeep from 'lodash.clonedeep'
import dayjs from 'dayjs'
const state = {
  formData: {},
  formConfig:[],
  rid:null,
  selectUnit:null
}

const getters = {
  getFormData: state => key => {
    return state.formData[key]
  },
  getFormConfigByName: state => name => {
    // return state.subFormData
    return state.formConfig.filter(element => element.componentName == name)[0]
  },
  getSubmitFormConfig:(state,getters,rootState)=>name=>{
    //深拷贝，不影响vuex数据
    const formConfig = clonedeep(state.formConfig)
    //项目委托加上时间
    formConfig[1].data['YYRQ'] = dayjs().format('YYYY-MM-DD HH:mm:ss') 
    
    //插userid和rid
    const userId =  rootState.userInfo?.RID
    const rid = state.rid
    console.log('user',userId,name)
    const userData = {
      userID:userId,
      docunid:'',
      RID:rid
    }
    formConfig.push(userData)
    //插当前页
    let currentPage= null
    let componentDesc = ''
    for(let i=0;i<formConfig.length;i++){
      const element = formConfig[i]
      if(element.componentName==name){
        currentPage = i
        componentDesc = element.componentDesc
        break
      }
    }
    const currentData = {
      current:currentPage,
      currentComponentDesc:componentDesc,
      currentComponentName:name
    }
    formConfig.push(currentData)
    return formConfig
  }
}

const mutations = {
  setFormConfig(state, data) {
    state.formConfig = data
  },
  setSelectUnit(state,data){
    state.selectUnit = data
  },
  setFormData(state, data) {
    if(Object.hasOwnProperty.call(data,'CascaderSelect')){
      state.formConfig.forEach(element => {
        if(element.componentName=='CascaderSelect'){
          element.data.CLSX=data['CascaderSelect']
          if(state.selectUnit){
            element.data.CLSX.forEach(item=>{
              item.CHZYDWRID =state.selectUnit.rid
              item.cldw= state.selectUnit.unitName
              item.userId=state.selectUnit.userId
            })
          }
        }
      });
    }else if(Object.hasOwnProperty.call(data,'ProjectAppointOrgan')){
      state.formConfig.forEach(element=>{
        if(element.componentName=='CascaderSelect'){
          element.data.CLSX.forEach(item=>{
            item.CHZYDWRID = data['ProjectAppointOrgan'].rid
            item.cldw= data['ProjectAppointOrgan'].dwmc
            item.userId=data['ProjectAppointOrgan'].USERID
            // console.log('123',item,data['ProjectAppointOrgan'])
          })
        }
      })
    }else if (Object.hasOwnProperty.call(data,'FileTable')){
      state.formConfig.forEach(element=>{
        if(element.componentName=='FileTable'){
          element.data.files=data['FileTable']
        }
      })
    }
  },
  setFormConfigPermission(state,data){
    if(Object.hasOwnProperty.call(data,'CommonFormFinal')){
      state.formConfig.forEach(element =>{
        if(element.componentName=='CommonFormFinal'){
          element.permission = data['CommonFormFinal']
        }
      })
    }
  },
  setRid(state,data){
    state.rid= data
  },
  removeRid(state){
    state.rid=null
    state.selectUnit=null
  }

}
const actions = {}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
